module.exports = __webpack_public_path__ + "static/media/weight-hanging.77cc5164.svg";